export default () => {
  $('.owl-menu').owlCarousel({
    margin: 20,
    loop: false,
    dots: false,
    nav: false,
    autoWidth: true,
    items: 4
  });

  window.onload = function () {
    const url = location.pathname;
    let regex = `^.*${url}$`;
    regex = regex.split('/').join( '\\/');
    const nav = document.getElementById('nav-carrousel');

    nav.getElementsByClassName('owl-item').forEach(function (element) {
      if (element.getElementsByTagName('a')[0]?.href.match(regex)) {
        element.classList.add('activecategory');
      }
    });
  }
}
